module.exports = __webpack_public_path__ + "img/card-specialists.f18b9c32.svg";